const clientAppCloudFunction = process.env.REACT_APP_DS_SPECIALS_CLIENT_APP;
export default clientAppCloudFunction;
